import React, { useState } from 'react';
import MDModal from 'components/MDModal';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDInput from 'components/MDInput';
import MDButton from 'components/MDButton';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import Editor from 'components/editor';
import { useAppServices } from 'hook/services';
import { useParams } from 'react-router-dom';

const CreatePromptModal = ({ handleRefresh }) => {
  const AppService = useAppServices();

  const [open, setOpen] = useState(false);
  const [processing, setProcessing] = useState(false);
  const [description, setDescription] = useState('');
  const [name, setName] = useState('');

  const handleModal = () => setOpen(true);
  const closeModal = () => setOpen(false);

  const extractVariables = (text) => {
    const regex = /{{([^}]+)}}|{@([^}]+)}|{\(([^)]+)\)}/g;
    const matches = new Set();
    let match;
    while ((match = regex.exec(text)) !== null) {
      const variable = match[1] || match[2] || match[3];
      if (variable) matches.add(variable.trim());
    }
    return Array.from(matches);
  };

  const stripHTML = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || "";
};


  const handleSubmit = async (e) => {
    e.preventDefault();
    setProcessing(true);

const cleanedDescription = stripHTML(description);
const dynamic_variables = extractVariables(cleanedDescription);

    const payload = {
      name,
      instructions: cleanedDescription,
      dynamic_variables,
      created_by: "superadmin",
     
    };

    const { response } = await AppService.ai_prompt_templates.create({ payload });

    if (response?.success) {
      closeModal();
      handleRefresh();
    }

    setProcessing(false);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 612,
    maxHeight: '80vh',
    overflow: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  return (
    <>
      <MDButton color="white" variant="contained" onClick={handleModal}>
        Create Prompt
      </MDButton>

      <MDModal open={open} onClose={closeModal}>
        <MDBox component="form" onSubmit={handleSubmit} sx={style}>
          <MDTypography variant="h5" mb={2}>
            Create Prompt
          </MDTypography>

          <MDBox mb={2}>
            <MDTypography variant="button">Name</MDTypography>
            <MDInput
              label="Name"
              name="name"
              fullWidth
              required
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </MDBox>

          <MDBox mb={2}>
            <MDTypography variant="button">Instructions</MDTypography>
            <Editor handleChange={setDescription} />
          </MDBox>



          <MDBox display="flex" justifyContent="flex-end">
            <MDButton variant="gradient" color="primary" type="button" onClick={closeModal}>
              Close
            </MDButton>
            <MDButton
              variant="gradient"
              color="info"
              type="submit"
              sx={{ ml: 1 }}
              disabled={processing}
            >
              Add
            </MDButton>
          </MDBox>
        </MDBox>
      </MDModal>
    </>
  );
};

export default CreatePromptModal;
